import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  EduCourseDatesEdit,
  EduCourseEdit,
  EduCourseDetailPage,
  EduCoursesPage,
  EduParticipantsPage,
  MyEduCourseDatesPage,
} from '../pages/CMSPages/index';
import React from 'react';

const FriEduRoutes = () => (
  <>
    <Route
      path={`${routes.cmsCoursesList}`}
      element={
        <CMSWrapper permissions={['fri-edu-courses.index']}>
          <EduCoursesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsCoursesCreate}`}
      element={
        <CMSWrapper permissions={['fri-edu-courses.store']}>
          <EduCourseEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsCoursesEdit}/:id`}
      element={
        <CMSWrapper permissions={['fri-edu-courses.update']}>
          <EduCourseEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsCourseDetail}/:id`}
      element={
        <CMSWrapper permissions={['fri-edu-courses.show']}>
          <EduCourseDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsEduDatesCreate}/:courseId`}
      element={
        <CMSWrapper permissions={['fri-edu-course-dates.store']}>
          <EduCourseDatesEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsEduDates}/:courseId/edit/:dateId`}
      element={
        <CMSWrapper permissions={['fri-edu-course-dates.update']}>
          <EduCourseDatesEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsEduDateParticipants}/:dateId`}
      element={
        <CMSWrapper permissions={['fri-edu-course-dates.show']}>
          <EduParticipantsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsEduMyDates}`}
      element={
        <CMSWrapper permissions={['fri-edu-course-dates.index']}>
          <MyEduCourseDatesPage />
        </CMSWrapper>
      }
    />
  </>
);

export default FriEduRoutes;
